<template>
    <div class="faq-page">
        <HeaderMenu></HeaderMenu>
        <div class="main_content">
            <section class="bread_crumb">
                <div class="container">
                    <ul>
                        <li><router-link v-bind:to="'/'">Home</router-link></li> 
                        <li>FAQ</li>
                    </ul>
                </div>
            </section>
            <div class="mission_banner_wrapper custom-banner-section">
                <div class="about_main_image">
                    <img src="https://testuc222.sirv.com/Images/NAMA/faq.png" alt="FAQ Banner" />
                    <div class="about_main_title">
                        <h4>FAQ</h4>
                    </div>
                </div>
                <div class="faq_tabs_sec">
                    <div class="container" >
                        <div id="accordion" >
                            <div class="card" v-if="faqs!=null" v-for="(faq, index) in faqs">
                                <div class="card-header">
                                    <a class="card-link" data-toggle="collapse"  :href="'#faq'+faq.id"  :aria-expanded="index==0 ? true : false ">
                                        {{ faq.heading_eng }} <span class="tab_toggle_icon">+</span>
                                    </a>
                                </div>
                                <div :id="'faq'+faq.id" class="collapse" :class="{show:index==0}" data-parent="#accordion">
                                    <div class="card-body"  v-if="current_locale=='en'" v-html="faq.description_eng">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import HeaderMenu from '../HeaderMenu'
import router from '../../router'

export default{
    data(){
        this.get_page_content();
        return {
            faqs:null,
            current_locale:this.$i18n_global.locale
        }
    },
    components:{
        HeaderMenu:HeaderMenu
    },
    methods:{
        async get_page_content() {
            var _self = this; 
            await axios.post(_self.$hostname+'/api/faq')
            .then((res) => {
                var response = res.data.data;
                _self.faqs = response;
            })
            .catch((error) => {
                console.log(error.response.data.error);
                return false;  
            }) 
            return false; 
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Pages/Faq.vue